import React from "react";
import { BsMap, BsHeart, BsTelephone } from "react-icons/bs";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
import image from "../images/desenho.jpg";

const StrContent = () => {
  return (
    <ContentStyled image={image}>
      <Fade left>
        <h1>INTERNAÇÕES E REMOÇÕES</h1>
        <InfoCardContainer>
          <InfoCard>
            <div>
              <BsMap />
              <img src="https://ohhappyway.com/wp-content/uploads/2021/06/brasilia-fotos-aereas-eixao-norte-simetria-avenida.jpg" />
            </div>
            <h2>Nossas Unidades</h2>
            <p>
              Oferecemos acomodações confortáveis e espaços de convivência,
              salas de terapia e refeitório para garantir uma estadia relaxante
              e agradável aos pacientes em nossas unidades de reabilitação.
            </p>
          </InfoCard>
          <InfoCard>
            <div>
              <BsHeart />
              <img src="https://mediflix.com.br/wp-content/uploads/2020/03/clinica-medica.jpg" />
            </div>
            <h2>Resgate e Remoção em Todo Brasil</h2>
            <p>
              Nossas unidades contam com equipe de profissionais treinados e
              preparados para conduzir com segurança nossos pacientes, visando
              uma recuperação tranquila e efetiva.
            </p>
          </InfoCard>
          <InfoCard>
            <div>
              <img src="https://assets-cdn.static-gm.com/Assets/09011c28-5683-4ffe-bc3b-35bfd3e2c865/5cbf8e8d-6178-4ea3-9f47-9055ee02cea3/Desktop.jpg" />
              <BsTelephone />
            </div>
            <h2>Fale Conosco</h2>
            <p>
              Entre em contato via telefone ou WhatsApp:
              (11)917721058. Nossa equipe de profissionais está pronta para
              ouvir e orientar nossos pacientes, oferecendo suporte e um ombro
              amigo.
            </p>
          </InfoCard>
        </InfoCardContainer>
      </Fade>
    </ContentStyled>
  );
};
export default StrContent;

const ContentStyled = styled.div`
  width: 100%;
  display: column;
  text-align: center;
  padding: 85px 20px;
  filter: drop-shadow(0px 0px 4px #3b3a3a);
  background-image: URL(${image});
  background-repeat: no-repeat;
  background-size: cover;
  ::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 1;
  }
  h1 {
    font-family: "Jost", sans-serif;
    font-size: 30px;
    font-weight: 550;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 500px;
    background-color: #fff;
    text-align: center;
    margin: auto;
    margin-bottom: 2.2rem;
    border-radius: 15px;
  }
  @media (max-width: 900px) {
    h1 {
      font-size: 2.2rem;
      line-height: 1.1;
    }
  }
  @media (max-width: 600px) {
    h1 {
      width: 90%;
    }
  }
`;
const InfoCard = styled.div`
  display: column;
  justify-content: center;
  text-align: left;
  width: 30%;
  height: 390px;
  padding: 0;
  font-family: "Jost", sans-serif;
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 3%;
  filter: drop-shadow(0px 0px 4px #3b3a3a);
  &:hover {
    filter: drop-shadow(0px 0px 5px #202020);
  }
  div {
    width: 100%;
    height: 180px;
    display: flex;
    position: relative;
    margin-bottom: 12px;

    svg {
      width: 50%;
      height: 50%;
      margin: auto;
      padding: 0.2% 0;
      color: #0e3d7b;
    }
    img {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      position: absolute;
      object-fit: cover;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  }

  h2 {
    width: 90%;
    margin: auto;
    font-size: 1.25rem;
    line-height: 1.4;
    font-weight: bold;
    margin-bottom: 5px;
  }
  p {
    width: 90%;
    margin: auto;
    font-size: 1.25rem;
    line-height: 1.4;
  }
  @media (max-width: 1500px) {
    width: 40%;
    margin-bottom: 20px;
    min-height: 300px;
    height: auto;

    div {
      height: 140px;
      svg {
        width: 80%;
        height: 80%;
      }
    }
    h2 {
      font-size: 1rem;
      line-height: 1.2;
      font-weight: bold;
    }
    p {
      font-size: 1rem;
      line-height: 1.2;
    }
  }
  @media (max-width: 900px) {
    width: 45%;
    margin-bottom: 20px;
    min-height: 300px;
    height: auto;
    div {
      height: 140px;
      svg {
        width: 80%;
        height: 80%;
      }
    }
    h2 {
      font-size: 1rem;
      line-height: 1.2;
      font-weight: bold;
    }
    p {
      font-size: 1rem;
      line-height: 1.2;
    }
  }
  @media (max-width: 500px) {
    width: 80%;
  }
`;
const InfoCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  justify-content: space-evenly;
  padding: 0 5%;
  div {
    display: flex;
    flex-wrap: wrap;
  }

  @media (max-width: 1500px) {
    width: 80%;
  }
  @media (max-width: 900px) {
    width: 100%;
    padding: 0 0;
    margin: auto;
  }
`;
